export default __webpack_public_path__ + "static/media/progressSuccessBlack.b07ee001.svg";